import React from 'react';

const AccordionShimmer: React.FC = () => {
    return (
        <div className="flex flex-col gap-2">
            {Array.from({ length: 10 }, (_, index) => (
                <div
                    key={index}
                    className="flex flex-row bg-gray-200 animate-pulse p-3 rounded-md h-16 items-center "
                >
                    <div className="bg-gray-300 rounded-full w-14 h-14"></div>
                    <div className="bg-gray-300 h-10 w-full ml-2 pl-2 flex items-center">
                        <p className=" text-black">Loading...</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AccordionShimmer;
